<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="freight-search-left">
				<div class="filters-container">
					<div class="input-box">
						<el-input
							v-model="product"
							placeholder="搜索"
							size="small"
							@keyup.enter.native="search">
							<!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="shop"
							filterable
							multiple
							collapse-tags
							placeholder="门店">
							<el-option
								v-for="item in shopList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="customer"
							filterable
							multiple
							collapse-tags
							placeholder="客户">
							<el-option
								v-for="item in kehuList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="category"
							filterable
							multiple
							collapse-tags
							placeholder="客户类别">
							<el-option
								v-for="item in customList"
								:key="item.ccid"
								:label="item.ccname"
								:value="item.ccid">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="level"
							filterable
							multiple
							collapse-tags
							placeholder="会员等级">
							<el-option
							v-for="(item,index) in levelList"
							:key='index'
							:value="item.customerlevelid"
							:label="item.level === 0 ? item.customerlevelname : item.levelName + (item.customerlevelname === '' ? '' : '-') + item.customerlevelname">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="normal"
							filterable
							multiple
							collapse-tags
							placeholder="常规运费模板">
							<el-option
								v-for="item in normalList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<el-select
							size="small"
							class="filter-input"
							v-model="special"
							filterable
							multiple
							collapse-tags
							placeholder="特殊商品运费模板">
							<el-option
								v-for="item in specialList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="freight-search-right">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3" v-if="AuthorityList['01_0003_0001_00']">
			<el-button size="small" type="primary" plain style="height:32px" @click="muitlSet">批量设置</el-button>
		</div>
		<el-dialog class="dialog-title" title="选择运费模板" :visible.sync="dialogModel" width='850px' :close-on-click-modal="false">
			<div class="type-box">
				<div>
					<el-radio-group v-model="templateType" size="small" @change="getTemplate">
						<el-radio-button :label="-1">全部模板({{temTotalCount}})</el-radio-button>
						<el-radio-button :label="0">整单运费({{temNormalCount}})</el-radio-button>
						<el-radio-button :label="1">特殊商品运费({{temSpecCount}})</el-radio-button>
					</el-radio-group>
				</div>
				<div style="width:250px">
					<el-input
						v-model="templateName"
						placeholder="搜索"
						size="small"
						@keyup.enter.native="getTemplate">
						<el-button slot="append" icon="el-icon-search" @click="getTemplate"></el-button>
					</el-input>
				</div>
			</div>
			<div class="template-list">
				<div class="template-li" v-for="(item, index) in templateList" :key="item.id" @click="toggleTemplate(item, index)">
					<div class="template-head">
						<i class="el-icon-caret-bottom" v-show="item.showFlag"></i>
						<i class="el-icon-caret-right" v-show="!item.showFlag"></i>
						<img src="~/images/icon/special-icon.png" v-if="item.type === 1">
						<span style="font-weight:bold">{{item.name}}</span>
						<span style="margin-left:10px" v-if="item.freeflag">
							参与免运费（
							<span v-if="item.freearea === 1"> 限区域 </span>
							<span v-if="item.freearea === 0">
								不限区域订单商品金额满{{ item.freemoney }}元
							</span>
							）
						</span>
						<div class="head-right" @click.stop="">
							<span v-if="item.checked">当前</span><el-checkbox v-model="item.checked" @change="checkHandle(item, index)"></el-checkbox>
						</div>
					</div>
					<div class="template-content" v-show="item.showFlag">
						<div v-if="item.type === 0">
							<el-table
								class="grid-content"
								:data="item.detailList"
								size="mini"
								ref="table"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="staffName"
									label="配送区域"
									align="center">
									<template slot-scope="scope">
										<el-tooltip effect="dark" :content="scope.row.areaname" placement="top-start">
											<div class="over-hidden">{{scope.row.showname}}</div>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column
									prop="freemoney"
									v-if="item.freeflag && item.freearea === 1"
									label="免运费规则"
									align="center">
									<template slot-scope="scope">
										<div>
											订单商品金额满{{ scope.row.freemoney }}元免运费
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="customerName"
									label="计费方式">
									<template slot-scope="scope">
										<div class="over-hidden" v-if="scope.row.pricingType === 0">一口价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 1">阶梯价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 2">比例价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 5">固定件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 6">阶梯件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 7">固定重量</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 9">阶梯件数：超出起步价部分，每件</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 10">阶梯件数：超出起步价部分，一律每件</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="itemCount"
									label="计费规则">
									<template slot-scope="scope">
										<div class="flex-two">
											<div class="rule-box" v-if="scope.row.pricingType === 0">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">一口价{{item.freightMoney}}元</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 1">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单金额于{{childItem.minValue}}元（含）~{{childItem.maxValue}}元（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 2">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">订单金额比例的{{item.percentMoney}}%</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 5">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}件（包含及以下）,{{item.freightMoney}}元；续费：超出每件{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + '件' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 6">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单件数于{{childItem.minValue}}件（含）~{{childItem.maxValue}}件（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 7">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}KG（包含及以下）,{{item.freightMoney}}元；续费：超出每KG{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + 'KG' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 9">
												<template>
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div v-if="childIndex === 0" class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），运费固定 {{childItem.freightMoney}} 元，{{ scope.row.detailtype === 1 ? '超出起送件数，超出部分每件' : '超出起送件数，每件' }}</div>
														<div v-else class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），按照每件 {{childItem.freightMoney}} 元收取</div>
													</div>
												</template>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 10">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">
													0-{{item.maxValue}}件，起步价{{item.freightMoney}}元，只要超出起步件数，一律按照每件{{item.stepMoney}}元收取
												</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-if="item.type === 1">
							<el-table
								class="grid-content"
								:data="item.detailList"
								ref="table2"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="showname"
									label="配送区域"
									align="center">
									<template slot-scope="scope">
										<div :title="scope.row.areaname">{{scope.row.showname}}</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productName"
									label="商品"
									align="center">
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productAttrplanName"
									label="规格"
									align="center">
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.pricingType === 3">计重</div>
											<div v-if="scope.row.pricingType === 8">计件：固定件数</div>
											<div v-if="scope.row.pricingType === 4">计件：阶梯件数</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费规则"
									align="center">
									<template slot-scope="scope">
										<div class="flex-two table-box">
											<div v-if="scope.row.pricingType === 4" style="text-align:left">
												<div class="rule-box two-box">
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div class="step-box">
															商品于{{childItem.minValue}}件（不含）~{{childItem.maxValue}}件（不含），收
															{{childItem.freightMoney}}元</div>
													</div>
													<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
												</div>
											</div>
											<div v-if="scope.row.pricingType === 3" style="text-align:left">
												商品于0kg（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}kg（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}kg，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
											<div v-if="scope.row.pricingType === 8" style="text-align:left">
												商品于0件（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}件（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}件，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-box">
				<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
				<el-button class="btn" size="small" type="primary" @click="confirmTemplate">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		tableData: {
			type: Array
		},
		customList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean
	},
	data () {
		return {
			collapse: false,
			methodValue: 2,
			percentValue: '',
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			bc: [],
			sc: [],
			disabledflag: -1,
			shop: [],
			customer: [],
			category: [],
			level: [],
			normal: [],
			special: [],
			product: '',
			shopList: [],
			levelList: [],
			kehuList: [],
			normalList: [],
			specialList: [],
			dialogModel: false,
			templateType: -1,
			templateName: '',
			templateList: [],
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			normalId: '',
			specialId: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('freightSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('freightSelect'))
			this.shop = data.shop
			this.category = data.category
			this.level = data.level
			this.normal = data.normal
			this.customer = data.customer
			this.product = data.product
			this.special = data.special
		}
		this.getShop()
		this.getCustom()
		this.getLevel()
		this.getNormal()
		this.getSpecial()
		if (this.$route.query.shopid) {
			this.shop = [this.$route.query.shopid]
		}
	},
	methods: {
		getLevel () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerLevelList`
			}).then(res => {
				this.levelList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		checkHandle (item, index) {
			this.templateList.forEach((e, i) => {
				if (i !== index && item.type === e.type) {
					e.checked = false
				}
			})
			if (item.type === 0) {
				this.normalId = item.checked ? item.id : ''
			} else if (item.type === 1) {
				this.specialId = item.checked ? item.id : ''
			}
		},
		confirmTemplate () {
			// let normalId = ''
			// let specialId = ''
			// this.templateList.forEach(e => {
			// 	if (e.checked) {
			// 		if (e.type === 0) {
			// 			normalId = e.id
			// 		} else if (e.type === 1) {
			// 			specialId = e.id
			// 		}
			// 	}
			// })
			let arr = []
			this.tableData.forEach(e => {
				if (this.ids.indexOf(e.uniqueId) !== -1) {
					let obj = {
						// id: e.id,
						customerId: e.customerId,
						shopId: e.shopId,
						freightTemplateId: this.normalId || 0,
						productFreightTemplateId: this.specialId || 0
					}
					arr.push(obj)
				}
			})
			let params = arr
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/relCustomerFreightTempalte/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('设置成功')
					this.$emit('modifySuc')
					this.dialogModel = false
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		close () {
			this.dialogModel = false
		},
		getTemplate () {
			let params = {
				name: this.templateName,
				type: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.temTotalCount = res.data.totalFreightTemplateCount
				this.temNormalCount = res.data.normalFreightTemplateCount
				this.temSpecCount = res.data.specialProductFreightTemplateCount
				if (res.data.freightTemplateDTOList !== null) {
					res.data.freightTemplateDTOList.forEach(e => {
						e.showFlag = false
						e.checked = false
						e.detailList = []
						if (this.chooseName === e.name) {
							e.checked = true
						}
					})
				}
				this.templateList = res.data.freightTemplateDTOList || []
			})
		},
		toggleTemplate (item, index) {
			if (item.detailList.length !== 0) {
				item.showFlag = !item.showFlag
			} else {
				let params = {
					id: item.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlSV}/order/freightTemplate/detail/get`,
					data: params
				}).then(res => {
					if (res.result === true) {
						if (item.type === 0) {
							let arr = []
							res.data.freightTemplateDetailDTOList.forEach(e => {
								if (e.areaname.split(',').length > 20) {
									e.showname = e.areaname.split(',').slice(0, 21).join(',') + '...'
								} else {
									e.showname = e.areaname
								}
								e.freemoney = this.$fxUtils.toFixedSHW(e.freemoney, 2)
								if (e.freightTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.freightTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.transportMode = 0
										row.pricingType = e.freightTemplatePricingDetail.pricingType
										row.detailtype = e.freightTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.simpleTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.simpleTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.pricingType = e.simpleTemplatePricingDetail.pricingType
										row.detailtype = e.simpleTemplatePricingDetail.detailtype
										row.transportMode = 1
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.coldChainTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.coldChainTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.transportMode = 2
										row.pricingType = e.coldChainTemplatePricingDetail.pricingType
										row.detailtype = e.coldChainTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								// e.freightTemplatePricingDTOList.forEach(item => {
								// 	item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
								// 	item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
								// 	if (item.pricingType !== 5 && item.pricingType !== 6) {
								// 		item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
								// 		item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
								// 	}
								// })
							})
							console.log(arr)
							item.detailList = arr
							this.colspanData(index)
						}
						if (item.type === 1) {
							// let newList = []
							res.data.freightTemplateProductAttrplanDTOList.forEach(item => {
								let nameArr = item.areaname.split(',')
								item.showname = item.areaname
								if (nameArr.length > 20) {
									item.showname = nameArr.slice(0, 21).join(',') + '...'
								}
								item.freeMoney = item.freightTemplatePricingDTOList[0].freeMoney
								item.topOffRadio = item.freeMoney === null ? '1' : '2'
								item.colspan = 1
								item.firstCol = true
								// if (item.freightTemplateProductAttrplanDTOList.length === 1) {
								// 	item.freightTemplatePricingDTOList = [item.freightTemplateProductAttrplanDTOList[0].freightTemplatePricingDTOList[0]]
								// 	item.pricingType = item.freightTemplateProductAttrplanDTOList[0].pricingType
								// 	item.productAttrplanId = item.freightTemplateProductAttrplanDTOList[0].productAttrplanId
								// 	item.productAttrplanName = item.freightTemplateProductAttrplanDTOList[0].productAttrplanName
								// 	item.productId = item.freightTemplateProductAttrplanDTOList[0].productId
								// 	item.productName = item.freightTemplateProductAttrplanDTOList[0].productName
								// 	item.freeMoney = item.freightTemplateProductAttrplanDTOList[0].freightTemplatePricingDTOList[0].freeMoney
								// 	newList.push(item)
								// } else {
								// 	let arr1 = []
								// 	for (let i = 0; i < item.freightTemplateProductAttrplanDTOList.length; i++) {
								// 		let e = item.freightTemplateProductAttrplanDTOList[i]
								// 		let newItem = this.$fxUtils.deepClone(item)
								// 		newItem.freightTemplatePricingDTOList = e.freightTemplatePricingDTOList
								// 		newItem.pricingType = e.pricingType
								// 		newItem.productAttrplanId = e.productAttrplanId
								// 		newItem.productAttrplanName = e.productAttrplanName
								// 		newItem.productId = e.productId
								// 		newItem.productName = e.productName
								// 		newItem.freeMoney = e.freightTemplatePricingDTOList[0].freeMoney
								// 		arr1.push(newItem)
								// 	}
								// 	newList.push(...arr1)
								// }
							})
							item.detailList = res.data.freightTemplateProductAttrplanDTOList
							this.colspanData(index)
						}
						// }
						item.showFlag = !item.showFlag
					}
				})
			}
		},
		colspanData (index) {
			// let copyData = this.$fxUtils.deepClone(this.templateList[index].detailList)
			// copyData[0].colspan = 1
			// copyData[0].firstCol = true
			// let num = 1
			// for (let i = 1; i < copyData.length; i++) {
			// 	let item = copyData[i]
			// 	item.colspan = 1
			// 	item.firstCol = true
			// 	if (item.areaname === copyData[i - 1].areaname) {
			// 		copyData[i - num].colspan = copyData[i - num].colspan + 1
			// 		copyData[i - num].firstCol = false
			// 		item.firstCol = false
			// 		num += 1
			// 	} else {
			// 		num = 1
			// 	}
			// }
			// this.templateList[index].detailList = copyData
			let copyData = this.sortClass(this.templateList[index].detailList)
			copyData.forEach(item => {
				if (item.length === 1) {
					item[0].colspan = 1
					item[0].firstCol = true
				} else {
					let num = 0
					let index = 0
					item.forEach((e, eIndex) => {
						e.colspan = 1
						e.firstCol = false
						// if (e.searchShow) {
						item[index].colspan = item[index].colspan + num
						if (num === 0) {
							if (eIndex === item.length - 1) {
								e.firstCol = true
							} else {
								index = eIndex
								num = 1
							}
						}
						// }
					})
				}
			})
			let finalData = []
			copyData.forEach(item => {
				finalData.push(...item)
			})
			this.templateList[index].detailList = finalData
		},
		sortClass (sortData) {
			const groupBy = (array, f) => {
				let groups = {}
				array.forEach((o) => {
					let group = JSON.stringify(f(o))
					groups[group] = groups[group] || []
					groups[group].push(o)
				})
				return Object.keys(groups).map((group) => {
					return groups[group]
				})
			}
			const sorted = groupBy(sortData, (item) => {
				return item.areaname // 返回需要分组的对象
			})
			return sorted
		},
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (column.property === 'freemoney') {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
			if (columnIndex === 0) {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		muitlSet () {
			if (this.ids.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			this.getTemplate()
			this.dialogModel = true
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		getCustom () {
			let data = {
				keyword: '',
				shopid: '',
				ccid: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfo4Business`,
				data: data
			}).then(res => {
				if (res.result) {
					this.kehuList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// getLevel () {
		// 	this.$store.dispatch('requestPost', {
		// 		url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerLevelList`
		// 	}).then(res => {
		// 		this.levelList = res.data
		// 	})
		// },
		getNormal () {
			let params = {
				type: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.normalList = res.data.freightTemplateDTOList || []
			})
		},
		getSpecial () {
			let params = {
				type: 1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.specialList = res.data.freightTemplateDTOList || []
			})
		},
		search () {
			this.$emit('handleSearch', { shop: this.shop, level: this.level, category: this.category, normal: this.normal, customer: this.customer, product: this.product, special: this.special })
		},
		clear () {
			this.shop = []
			this.normal = []
			this.special = []
			this.category = []
			this.customer = []
			this.level = []
			this.product = ''
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	justify-content: space-between
	line-height: 50px;
	width :100%;
	// min-width :600px;
	box-sizing: border-box
	text-align: left
	// flex-wrap: wrap
	.freight-search-left {
		display: flex;
		flex-wrap: wrap;
		flex: 1
	}
	.freight-search-right {
		display: flex;
		align-items: center
		flex-shrink: 0;
		width: 150px;
		height: 50px
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 15px
		.el-input {
			width: 200px
		}
		.filter-input {
			width: 200px
		}
	}
}
.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		max-height: 350px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				i {
					margin-right: 5px
				}
				img {
					margin-right: 5px
				}
				.head-right {
					margin-left: auto;
					span {
						margin-right: 5px
					}
				}
			}
		}
	}
	.btn-box {
		text-align: right;
		margin-top: 15px;
	}
</style>
<style lang="stylus">
.el-select__tags{
	height: 32px
}
</style>
